import type StoreTaskData from '@/types/StoreTaskData'
import { sendMessage } from '@/utils'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTaskStatusStore = defineStore('tasksStatus', () => {
  //TODO: replace individual task var to map or list of tasks
  //Note: daily is currently being set by each tab but is not being used
  const share = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const follow = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const followJustJoined = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const followByUsername = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const unfollow = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const bulkPrice = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const bulkOffer = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const autoOffer = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const scanCloset = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const calculateCloset = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const communityShare = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const activityReturner = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })
  const relist = ref({
    status: false,
    daily: false,
    taskData: { id: '', finishedItems: [], progressCount: 0, totalItemsCount: 0 } as StoreTaskData
  })

  const changeShareTaskProgress = (taskData: StoreTaskData) => {
    share.value.taskData = taskData
  }
  const changeFollowTaskProgress = (taskData: StoreTaskData) => {
    follow.value.taskData = taskData
  }
  const changeFollowJustJoinedTaskProgress = (taskData: StoreTaskData) => {
    followJustJoined.value.taskData = taskData
  }
  const changeFollowByUsernameTaskProgress = (taskData: StoreTaskData) => {
    followByUsername.value.taskData = taskData
  }
  const changeUnfollowTaskProgress = (taskData: StoreTaskData) => {
    unfollow.value.taskData = taskData
  }
  const changeBulkPriceTaskProgress = (taskData: StoreTaskData) => {
    bulkPrice.value.taskData = taskData
  }
  const changeBulkOfferTaskProgress = (taskData: StoreTaskData) => {
    bulkOffer.value.taskData = taskData
  }
  const changeCommunityShareTaskProgress = (taskData: StoreTaskData) => {
    communityShare.value.taskData = taskData
  }
  const changeRelistTaskProgress = (taskData: StoreTaskData) => {
    relist.value.taskData = taskData
  }
  const changeActivityReturnerTaskProgress = (taskData: StoreTaskData) => {
    activityReturner.value.taskData = taskData
  }

  const changeShareStatus = (status: boolean) => {
    share.value.status = status
    taskStatusUpdated()
  }
  const changeShareDaily = (daily: boolean) => {
    share.value.daily = daily
  }
  const changeRelistStatus = (status: boolean) => {
    relist.value.status = status
    taskStatusUpdated()
  }
  const changeRelistDaily = (daily: boolean) => {
    relist.value.daily = daily
  }
  const changeFollowStatus = (status: boolean) => {
    follow.value.status = status
    taskStatusUpdated()
  }
  const changeFollowDaily = (daily: boolean) => {
    follow.value.daily = daily
  }
  const changeFollowJustJoinedStatus = (status: boolean) => {
    followJustJoined.value.status = status
    taskStatusUpdated()
  }
  const changeFollowJustJoinedDaily = (daily: boolean) => {
    followJustJoined.value.daily = daily
  }
  const changeFollowByUsernameStatus = (status: boolean) => {
    followByUsername.value.status = status
    taskStatusUpdated()
  }
  const changeFollowByUsernameDaily = (daily: boolean) => {
    followByUsername.value.daily = daily
  }
  const changeUnfollowStatus = (status: boolean) => {
    unfollow.value.status = status
    taskStatusUpdated()
  }
  const changeUnfollowDaily = (daily: boolean) => {
    unfollow.value.daily = daily
  }
  const changeBulkPriceStatus = (status: boolean) => {
    bulkPrice.value.status = status
    taskStatusUpdated()
  }
  const changeAutoOfferStatus = (status: boolean) => {
    autoOffer.value.status = status
    taskStatusUpdated()
  }
  const changeBulkOfferStatus = (status: boolean) => {
    bulkOffer.value.status = status
    taskStatusUpdated()
  }
  const changeScanClosetStatus = (status: boolean) => {
    scanCloset.value.status = status
    taskStatusUpdated()
  }
  const changeCalculateClosetStatus = (status: boolean) => {
    calculateCloset.value.status = status
    taskStatusUpdated()
  }
  const changeCommunityShareStatus = (status: boolean) => {
    communityShare.value.status = status
    taskStatusUpdated()
  }
  const changeCommunityShareDaily = (daily: boolean) => {
    communityShare.value.daily = daily
  }
  const changeActivityReturner = (status: boolean) => {
    activityReturner.value.status = status
    taskStatusUpdated()
  }

  const taskStatusUpdated = () => {
    //handles any checks related to running tasks i.e. add a beforeunload handler in case a user redirects while a task is active
    if (isTaskRunning()) {
      window.onbeforeunload = () => {
        return 'Are you sure you want to leave this page?'
      }
      sendMessage({ message: 'tasks-tracker-update', isTaskRunning: true })
      return
    }

    window.onbeforeunload = null
    sendMessage({ message: 'tasks-tracker-update', isTaskRunning: false })
  }

  const isTaskRunning = () => {
    if (
      share.value.status ||
      relist.value.status ||
      follow.value.status ||
      followJustJoined.value.status ||
      followByUsername.value.status ||
      unfollow.value.status ||
      bulkPrice.value.status ||
      autoOffer.value.status ||
      bulkOffer.value.status ||
      scanCloset.value.status ||
      calculateCloset.value.status ||
      communityShare.value.status ||
      activityReturner.value.status
    )
      return true
    return false
  }

  return {
    share,
    relist,
    follow,
    followJustJoined,
    followByUsername,
    unfollow,
    bulkPrice,
    autoOffer,
    bulkOffer,
    scanCloset,
    calculateCloset,
    communityShare,
    activityReturner,
    changeShareStatus,
    changeFollowStatus,
    changeFollowJustJoinedStatus,
    changeFollowByUsernameStatus,
    changeUnfollowStatus,
    changeBulkPriceStatus,
    changeAutoOfferStatus,
    changeBulkOfferStatus,
    changeScanClosetStatus,
    changeCalculateClosetStatus,
    changeUnfollowDaily,
    changeFollowByUsernameDaily,
    changeFollowJustJoinedDaily,
    changeFollowDaily,
    changeShareDaily,
    changeCommunityShareStatus,
    changeCommunityShareDaily,
    changeActivityReturner,
    changeRelistDaily,
    changeRelistStatus,
    changeActivityReturnerTaskProgress,
    changeRelistTaskProgress,
    changeCommunityShareTaskProgress,
    changeBulkOfferTaskProgress,
    changeBulkPriceTaskProgress,
    changeUnfollowTaskProgress,
    changeFollowByUsernameTaskProgress,
    changeFollowJustJoinedTaskProgress,
    changeFollowTaskProgress,
    changeShareTaskProgress
  }
})
